import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { formatTimeValue, parseTimeInput } from '../../../../common/timeFormat';
const TimeField = ({ item, value, onChange, onBlur }) => {
  const config = item.field?.config || {};
  const display = (v) =>
    v === null || v === undefined || v === '' ? '' : formatTimeValue(v, config);
  const [draft, setDraft] = useState(() => display(value));
  const emitted = useRef(value);
  useEffect(() => {
    if (value !== emitted.current)
      setDraft(
        value === null || value === undefined || value === ''
          ? ''
          : formatTimeValue(value, item.field?.config)
      );
  }, [value, item.field?.config]);
  const parsed = parseTimeInput(draft, config);
  return (
    <TextField
      size="small"
      fullWidth
      id={item.field_id}
      name={item.field_id}
      value={draft}
      placeholder={config.clock_format === '12h' ? 'h:mm AM/PM' : 'HH:mm'}
      inputProps={{ 'aria-label': item.field?.label || 'Time', maxLength: 12 }}
      error={parsed === null}
      helperText={
        parsed === null
          ? 'Enter a valid time.'
          : config.clock_format === '12h'
            ? 'Example: 2:30 PM'
            : 'Example: 14:30'
      }
      onChange={(event) => {
        const next = event.target.value;
        setDraft(next);
        emitted.current = parseTimeInput(next, config) ?? next;
        onChange({ target: { name: item.field_id, value: emitted.current } });
      }}
      onBlur={(event) => {
        if (parsed !== null) setDraft(display(parsed));
        onBlur?.(event);
      }}
    />
  );
};
TimeField.propTypes = {
  item: PropTypes.shape({
    field_id: PropTypes.string.isRequired,
    field: PropTypes.shape({
      label: PropTypes.string,
      config: PropTypes.shape({ clock_format: PropTypes.oneOf(['12h', '24h']) })
    })
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func
};
export default TimeField;
